import routes from './routes';

export * from './Pages/index';
export * from './Components/index';
export * from './Contexts/index';
export * from './hooks/index';
export * from './reducers/index';
export default routes;
